import * as React from "react";
import { HeaderContent } from "~/components/header/HeaderContent";
import { useHideOnScroll } from "~/lib/use-hide-on-scroll";
import { useContainerSize } from "~/lib/use-container-size";

interface FollowHeaderProps {
    // Fires whenever this header's shown/hidden state changes — e.g. so a
    // parent can hide the normal <Header>'s now-redundant landmark while this
    // one is the one actually on screen.
    onVisibleChange?: (visible: boolean) => void;
    // Renders under the .fleet (dark) token scope, matching <Header variant="fleet">.
    fleet?: boolean;
}

// A separate, always-solid header that pins to the top and reveals on
// scroll-up / hides on scroll-down once scrolled past its own height. Render
// it alongside a normal <Header> (which stays in its natural placement and
// just scrolls away) when a page wants this "follows you" behavior.
export default function FollowHeader({ onVisibleChange, fleet = false }: FollowHeaderProps) {
    const [headerEl, setHeaderEl] = React.useState<HTMLElement | null>(null);
    const { height: headerHeight } = useContainerSize(headerEl, { width: 0, height: 64 });
    const [open, setOpen] = React.useState(false);
    const { y, visible } = useHideOnScroll(headerHeight, open);

    React.useEffect(() => {
        onVisibleChange?.(visible);
    }, [visible, onVisibleChange]);

    return (
        <HeaderContent
            transparent={false}
            fleet={fleet}
            wrapperClassName="fixed inset-x-0 top-0 z-50"
            style={{ y }}
            headerRef={setHeaderEl}
            onOpenChange={setOpen}
            ariaHidden={!visible}
        />
    );
}
